import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 0 * 60 + 0);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-orange text-white py-1.5 px-3 flex items-center justify-center gap-3 md:gap-5 sticky top-0 z-50 shadow-md" data-id="element-154">
      <div className="flex items-center gap-1.5 text-[10px] md:text-xs font-bold uppercase tracking-wide" data-id="element-155">
        <Zap size={12} className="fill-white" data-id="element-156" />
        <span data-id="element-157">¡Oferta relámpago!</span>
      </div>

      <div className="flex items-center gap-0.5" data-id="element-158">
        {[pad(h), pad(m), pad(s)].map((val, idx) => <div key={idx} className="flex items-center" data-id="element-159">
            {idx > 0 && <span className="text-white font-bold text-sm mx-0.5" data-id="element-160">:</span>}
            <span className="bg-navy text-white font-heading font-bold text-sm px-1.5 py-0.5 rounded min-w-[28px] text-center" data-id="element-161">
              {val}
            </span>
          </div>)}
      </div>
    </div>;
}